// Shared entity graph for full-site schema consistency.
// Stable @ids let Google/AI merge nodes into one entity instead of duplicating them.
import { SITE_URL } from "@/lib/api";

export const ORG_ID = `${SITE_URL}/#organization`;
export const BIZ_ID = `${SITE_URL}/#business`;
export const SITE_ID = `${SITE_URL}/#website`;

export function orgGraph(company = {}) {
  const social = Object.values(company.social || {}).filter(Boolean);
  return [
    {
      "@context": "https://schema.org", "@type": "Organization", "@id": ORG_ID,
      name: company.name, url: SITE_URL, logo: `${SITE_URL}/logo-full.webp`,
      telephone: company.phone, email: company.email, sameAs: social,
    },
    {
      "@context": "https://schema.org", "@type": "WebSite", "@id": SITE_ID,
      url: SITE_URL, name: company.name, publisher: { "@id": ORG_ID },
      potentialAction: { "@type": "SearchAction", target: `${SITE_URL}/blog?q={search_term_string}`, "query-input": "required name=search_term_string" },
    },
    {
      "@context": "https://schema.org", "@type": "HVACBusiness", "@id": BIZ_ID,
      name: company.name, url: SITE_URL, telephone: company.phone, email: company.email,
      image: `${SITE_URL}/logo-full.webp`, parentOrganization: { "@id": ORG_ID },
      address: { "@type": "PostalAddress", addressLocality: company.city, addressRegion: company.region, postalCode: company.postal_code, addressCountry: "US" },
      areaServed: (company.counties || []).map((c) => ({ "@type": "AdministrativeArea", name: c })),
      openingHours: "Mo-Su 07:00-20:00", sameAs: social,
    },
  ];
}

export const providerRef = () => ({ "@id": BIZ_ID });
export const orgRef = () => ({ "@id": ORG_ID });

export function webPage(path, name, description, type = "WebPage") {
  return {
    "@context": "https://schema.org", "@type": type, "@id": `${SITE_URL}${path}#webpage`,
    url: `${SITE_URL}${path}`, name, description, isPartOf: { "@id": SITE_ID }, about: { "@id": BIZ_ID },
  };
}
